module.exports = __webpack_public_path__ + "static/media/bts_lalela_170705_005_small.58b7373c.jpg";